import { render, staticRenderFns } from "./SalesTotalQuotationNumberDisplayer.vue?vue&type=template&id=0f368cca"
import script from "./SalesTotalQuotationNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./SalesTotalQuotationNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports